import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import Api from "api/Api";

const api = new Api();

const initialState = {
  taskIds: [],
  doneTasks: [],
  dismissed: false,
  status: "idle",
  error: null,
  isExpanded: true,
  expandedTaskId: null,
};

export const fetchOnboarding = createAsyncThunk(
  "onboarding/fetchOnboarding",
  async (_, { getState }) => {
    const state = getState();
    const companyId = state.company.id;

    if (!companyId) {
      throw new Error("Company ID not available");
    }

    const response = await api.getOnboarding(companyId);
    return response;
  },
);

export const updateTask = createAsyncThunk(
  "onboarding/updateTask",
  async ({ taskId, done }, { getState }) => {
    const state = getState();
    const companyId = state.company.id;

    if (!companyId) {
      throw new Error("Company ID not available");
    }

    const response = await api.updateOnboardingTask(companyId, taskId, done);
    return response;
  },
);

export const setDismissed = createAsyncThunk(
  "onboarding/setDismissed",
  async (dismissed, { getState }) => {
    const state = getState();
    const companyId = state.company.id;

    if (!companyId) {
      throw new Error("Company ID not available");
    }

    const response = await api.setOnboardingDismissed(companyId, dismissed);
    return response;
  },
);

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    resetOnboarding: () => {
      return initialState;
    },
    toggleExpanded: (state) => {
      state.isExpanded = !state.isExpanded;
    },
    toggleTaskExpanded: (state, action) => {
      state.expandedTaskId =
        state.expandedTaskId === action.payload ? null : action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchOnboarding.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOnboarding.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.taskIds = action.payload.allTasks || [];
        state.doneTasks = action.payload.doneTasks || [];
        state.dismissed = action.payload.dismissed || false;
      })
      .addCase(fetchOnboarding.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateTask.fulfilled, (state, action) => {
        state.taskIds = action.payload.allTasks || state.taskIds;
        state.doneTasks = action.payload.doneTasks || [];
        state.dismissed = action.payload.dismissed || false;
      })
      .addCase(setDismissed.fulfilled, (state, action) => {
        state.taskIds = action.payload.allTasks || state.taskIds;
        state.doneTasks = action.payload.doneTasks || [];
        state.dismissed = action.payload.dismissed || false;
      });
  },
});

export const { resetOnboarding, toggleExpanded, toggleTaskExpanded } = onboardingSlice.actions;

export const selectOnboarding = (state) => state.onboarding;
export const selectDoneTasks = (state) => state.onboarding.doneTasks;
export const selectCompletedCount = (state) =>
  state.onboarding.doneTasks.length;
export const selectIsAllCompleted = (state) =>
  state.onboarding.doneTasks.length === state.onboarding.taskIds.length;

export default onboardingSlice.reducer;
